import React, { useContext, useEffect, useState } from "react"
import { Row, Col, Modal, Form } from "react-bootstrap"
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import DatePicker from "react-datepicker"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/DataTable"
import {
  capitalizeFirstLetter,
  dateFormat,
  numberFormat,
  refreshPage,
  selectDropdownStyle,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import { getPurchaseReturn } from "../../../Helpers/apiCalls/Purchases/purchaseReturnApi"
import moment from "moment"
import {
  deletePurchaseReplacement,
  getPurchaseReplacement,
} from "../../../Helpers/apiCalls/Purchases/purchaseReplacementApi"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import toast from "react-hot-toast"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import Footer from "../../../Components/Footer/Footer"
import { Context } from "../../../Helpers/Utils/Context"
import { setDate } from "date-fns"

export default function PurchaseReplacement() {
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)
  const navigate = useNavigate()
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [purchaseReturns, setPurchaseReturns] = useState([])
  const [tableData, setTableData] = useState([])
  const [selectedId, setSelectedId] = useState()
  const [selectedRow, setSelectedRow] = useState()
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [suppliers, setSuppliers] = useState([])
  const [branches, setBranches] = useState([])
  const today = new Date()
  const aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)

  const [filterConfig, setFilterConfig] = useState({
    term: "",
    date_from: dateFilter.date_from ? dateFilter.date_from : aweekago,
    date_to: dateFilter.date_to ? dateFilter.date_to : today,
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row)
    if (e.target.value === "edit") {
      navigate("/purchasereplacement/edit/" + row.id)
    } else if (e.target.value === "print") {
      navigate("/purchasereplacement/view/" + row.id)
    } else if (e.target.value === "delete") {
      setShowDeleteModal(true)
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
        value={""}
      >
        <option value="" hidden selected>
          Select
        </option>
        <option value="edit" className="color-options">
          Edit
        </option>
        <option value="print" className="color-options">
          View
        </option>
        <option value="delete" className="color-red">
          Delete
        </option>
      </Form.Select>
    )
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        onClick={(e) => handleSelectChange(e, row)}
        value="print"
      >
        View
      </button>
    )
  }

  function InvoiceBtn(row) {
    return (
      <button
        type="button"
        className="button-secondary table-button me-3"
        onClick={() => handleViewInvoice(row.receive_id)}
      >
        {`INV. ${row.invoice_no}`}
      </button>
    )
  }
  function handleViewInvoice(id) {
    window.open("/purchaseinvoices/print/" + id, "_blank")
  }

  function ReturnBtn(row) {
    return (
      <button
        type="button"
        className="button-secondary table-button me-3"
        onClick={() => handleViewReturn(row.purchase_return_id)}
      >
        {`NO. ${row.purchase_return_id}`}
      </button>
    )
  }
  function handleViewReturn(id) {
    window.open("/purchasereturn/view/" + id, "_blank")
  }

  async function handleDelete() {
    if (!isClicked) {
      setIsClicked(true)
      const response = await deletePurchaseReplacement(selectedRow.id)
      if (response.data) {
        toast.success("Successfully deleted purchase replacement", {
          style: toastStyle(),
        })
        setShowDeleteModal(false)
        setTimeout(() => {
          refreshPage()
        }, 1000)
      } else {
        toast.error("Error deleting purchase return", { style: toastStyle() })
      }
      setIsClicked(false)
    }
  }

  async function fetchSuppliers() {
    setSuppliers([])

    const response = await getAllSuppliers()
    if (response.data) {
      var allData = response.data.data.map((supplier) => {
        var info = supplier
        info.label = supplier.trade_name
        info.value = supplier.id
        return info
      })
      setSuppliers([{ label: "All Suppliers", value: "" }, ...allData])
    }
  }

  async function fetchBranches() {
    setBranches([])
    const response = await getAllBranches()
    if (response.error) {
    } else {
      var allBranches = response.data.data.data.map((data) => {
        var branch = data
        branch.label = data.name
        branch.value = data.id
        return branch
      })
      setBranches([{ label: "All Branches", value: "" }, ...allBranches])
    }
  }

  async function fetchPurchaseReturns() {
    const response = await getPurchaseReturn()
    if (response.data) {
      const res = response.data.data.map((row) => {
        var info = {}
        info.label = `${row.id} - ${capitalizeFirstLetter(
          row.supplier_name
        )} - (returned on ${moment(row.return_date).format("MMM DD, YYYY")})`
        info.value = row.id
        return info
      })
      setPurchaseReturns(res)
    }
  }

  async function fetchPurchaseReplacements() {
    setTableData([])
    setTotalItems(0)
    setShowLoader(true)
    const response = await getPurchaseReplacement(filterConfig)
    if (response.data) {
      const res = response.data.data.map((row) => {
        var info = row
        info.replacement_date = dateFormat(row.replacement_date)
        info.grand_total = numberFormat(row.grand_total)
        return info
      })
      setTableData(res)
      setTotalItems(response.data.size)
    }
    setShowLoader(false)
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return {
        ...prev,
        [name]: value,
      }
    })
  }

  useEffect(() => {
    fetchPurchaseReturns()
    fetchSuppliers()
    fetchBranches()
  }, [])

  useEffect(() => {
    fetchPurchaseReplacements()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              PURCHASE REPLACEMENT{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="invoice_no"
              placeHolder="Search Invoice No/DR no.."
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button className="add-btn" onClick={() => setShowAddModal(true)}>
                Add
              </button>
            </div>
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyle}
                options={suppliers}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      supplier_id: e.value,
                    }
                  })
                }}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Branch"
                styles={selectDropdownStyle}
                // value={branch}
                options={branches}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return { ...prev, branch_id: e.value }
                  })
                }}
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_from}
                placeholderText={"Select Date"}
                name="date_from"
                onChange={(date) => {
                  setDateFrom(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date }
                  })
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormat="MMM DD, yyyy"
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_to}
                placeholderText={"Select Date"}
                name="date_to"
                onChange={(date) => {
                  setDateTo(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_to: date }
                  })
                }}
                minDate={filterConfig.date_from}
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormat="MMM DD, yyyy"
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className="mb-2" />
          <TableWithDynamicPagination
            tableHeaders={[
              "-",
              "DATE",
              "SUPPLIER",
              "BRANCH",
              "INV NO.",
              "RETURN NO.",
              "TOTAL",
              "REPLACEMENT NO.",
              "ACTIONS",
            ]}
            headerSelector={[
              "-",
              "replacement_date",
              "supplier_name",
              "branch_id_name",
              "invoice_no",
              "purchase_return_id",
              "grand_total",
              "id",
            ]}
            tableData={tableData}
            ActionBtn={(row) => ActionBtn(row, "open")}
            ViewBtn={(row) => ViewBtn(row)}
            newTabBtn={(row) => InvoiceBtn(row)}
            PendingBtn={(row) => ReturnBtn(row)}
            tableType={"purchase return"}
            showLoader={showLoader}
            // used in dynamic pagination
            totalItems={totalItems}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handlePageChange={handlePageChange}
          />
          <Modal
            show={showAddModal}
            onHide={() => setShowAddModal(false)}
            size="lg"
            centered
          >
            <Modal.Body>
              <span className="PI-modal-header">ADD PURCHASE INVOICE</span>
              <div className="PI-modal-body mt-3">
                <span className="PI-modal-label">Purchase Return No.</span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Purchase Return..."
                  value={
                    purchaseReturns.filter(
                      (info) => info.value === selectedId
                    )[0]
                  }
                  options={purchaseReturns}
                  onChange={(e) => setSelectedId(e.value)}
                />
              </div>
            </Modal.Body>
            <Modal.Footer className="PI-modal-buttons">
              <button
                type="button"
                onClick={() => setShowAddModal(false)}
                className="button-secondary"
              >
                Close
              </button>
              <button
                type="button"
                onClick={() =>
                  navigate(`/purchasereplacement/add/${selectedId}`)
                }
                className="button-primary"
              >
                Continue
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        text="purchase return"
        onDelete={handleDelete}
        isClicked={isClicked}
      />
      <Footer />
    </div>
  )
}
